const productReviewsContainer = document.getElementById(
  "product-reviews-container",
);
const productReviewPrevButtonElement = document.getElementById(
  "product-review-prev-button",
);
const productReviewNextButtonElement = document.getElementById(
  "product-review-next-button",
);
const writeAReviewModalElement = document.getElementById(
  "write-a-review-container",
);

const STAR_FILLED =
  "https://cdn.shopify.com/s/files/1/0172/4383/2374/files/review-star.svg?v=1664876201";
const STAR_EMPTY =
  "https://cdn.shopify.com/s/files/1/0172/4383/2374/files/Star_5.svg?v=1666143946";
const YOTPO_APP_KEY = "dnGeaU8oseqC9z4WBEDYoZAWrjMbpQRCp42vUZ4B";
const YOTPO_MAX_REVIEW_IMAGES = 3;
const YOTPO_REVIEW_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "image/webp",
];

let reviewGalleryLoaded = false;
const reviewPreviewCache = new Map();
const reviewGalleryPreviewCache = new Map();
let reviewPreviewState = { reviewId: null, imageIndex: 0 };

function getReviewPreviewData(reviewId) {
  const id = String(reviewId);
  return reviewPreviewCache.get(id) || reviewGalleryPreviewCache.get(id);
}

const productId = productReviewsContainer?.dataset?.productId ?? "";
const productTitle = productReviewsContainer?.dataset?.productTitle ?? "";
const productUrl = productReviewsContainer?.dataset?.productUrl ?? "";
const productDescription =
  productReviewsContainer?.dataset?.productDescription ?? "";
const productImageUrl =
  productReviewsContainer?.dataset?.productImageUrl ?? "";
const shopDomain = productReviewsContainer?.dataset?.shopDomain ?? "";

const mainShopifyData = JSON.parse(
  document.getElementById("ShopifyData")?.innerHTML ?? "{}",
);

async function getProductReviews({
  productId,
  page = 1,
  direction = "desc",
  sort = "rating",
  star,
  per_page = 5,
}) {

  try {
    let url = `https://api-cdn.yotpo.com/v1/widget/dnGeaU8oseqC9z4WBEDYoZAWrjMbpQRCp42vUZ4B/products/${productId}/reviews.json?per_page=${per_page}&page=${page}&direction=${direction}&sort=${sort}${
      !!star ? "&star=" + star : ""
    }`;

    let options = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    const res = await fetch(url, options);
    const { response: data, status } = await res.json();

    if (status.code === 200) {
      return data;
    } else {
      console.error("error: ", status.message);
      return {};
    }
  } catch (error) {
    console.error("error:" + error);
    return {};
  }
}

// Alternative API
async function getProductReviewsSearchApi({
  productId,
  page = 1,
  direction = "desc",
  sort = "rating",
  star,
  pictured = false,
  per_page = 5,
}) {

  try {
    let url = `https://api-cdn.yotpo.com/v1/reviews/dnGeaU8oseqC9z4WBEDYoZAWrjMbpQRCp42vUZ4B/filter.json?per_page=${per_page}&page=${page}`;
    const ascending = direction === 'asc' ? true : false
    const sort_by = sort === 'rating' ? 'score' : sort
    const scores = star ? [star] : [] 
    let options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        domain_key: productId,
        scores,
        pictured,
        sort_by,
        ascending
      })
    };

    const res = await fetch(url, options);
    const { response: data, status } = await res.json();

    if (status.code === 200) {
      return data;
    } else {
      console.error("error: ", status.message);
      return {};
    }
  } catch (error) {
    console.error("error:" + error);
    return {};
  }
}

function initializeReviewPaginationValues(currentPage, totalPage) {
  const productReviewPagination = $("#product-review-current-page").closest(".product-review-pagination");
  const currentPageElement = document.getElementById(
    "product-review-current-page",
  );
  const totalPageElement = document.getElementById("product-review-total-page");
  if (totalPage <= 1){
    productReviewPagination.hide()
  }else{
    productReviewPagination.show()
  }
  currentPageElement.innerText = currentPage;
  totalPageElement.innerText = totalPage;
}

function preventPaginationOvershooting(currentPage, totalPage, direction) {
  if (currentPage <= 1 && direction === "PREV") return true;
  if (currentPage >= totalPage && direction === "NEXT") return true;

  return false;
}

function resetPaginationButtonColors() {
  productReviewPrevButtonElement?.classList.remove("is-disabled");
  productReviewNextButtonElement?.classList.remove("is-disabled");
}

function updatePaginationButtonColors(currentPage, totalPage) {
  resetPaginationButtonColors();

  if (currentPage <= 1) {
    productReviewPrevButtonElement?.classList.add("is-disabled");
  }

  if (currentPage >= totalPage) {
    productReviewNextButtonElement?.classList.add("is-disabled");
  }
}

function getFormattedDate(date) {
  let year = date.getFullYear().toString().slice(-2);
  let month = (1 + date.getMonth()).toString().padStart(2, "0");
  let day = date.getDate().toString().padStart(2, "0");

  return month + "/" + day + "/" + year;
}

function formatReviewDetails({ createdAt, userName }) {
  const formattedUserName = userName.split(" ").find(Boolean).toLowerCase();
  const dateCreated = new Date(createdAt);
  const formattedDateCreated = getFormattedDate(dateCreated);

  return {
    createdAt: formattedDateCreated,
    userName: formattedUserName,
  };
}

function renderReviewStars(container, score) {
  if (!container) return;

  container.innerHTML = "";
  const numOfStars = Math.round(+score);

  for (let i = 0; i < 5; i++) {
    const starImageElement = document.createElement("img");
    starImageElement.setAttribute("loading", "lazy");
    starImageElement.src = numOfStars - 1 < i ? STAR_EMPTY : STAR_FILLED;
    container.append(starImageElement);
  }
}

function getStarDistribution(bottomline) {
  return bottomline?.star_distribution || bottomline?.starDistribution || null;
}

function renderStarDistribution(bottomline) {
  const container = document.getElementById("product-reviews-distribution");
  if (!container) return;

  const distribution = getStarDistribution(bottomline);
  const total = bottomline?.total_review || 0;

  container.innerHTML = "";

  if (!distribution || !total) {
    container.hidden = true;
    return;
  }

  container.hidden = false;

  for (let star = 5; star >= 1; star--) {
    const count = Number(distribution[star] ?? distribution[String(star)] ?? 0);
    const width = total ? Math.round((count / total) * 100) : 0;

    const row = document.createElement("div");
    row.className = "product-reviews-distribution__row";

    const labelGroup = document.createElement("span");
    labelGroup.className = "product-reviews-distribution__label-group";

    const label = document.createElement("span");
    label.className = "product-reviews-distribution__label";
    label.textContent = star;

    const starIcon = document.createElement("img");
    starIcon.src = STAR_FILLED;
    starIcon.width = 14;
    starIcon.height = 14;
    starIcon.loading = "lazy";
    starIcon.className = "product-reviews-distribution__label-group-star";
    starIcon.alt = "";
    starIcon.setAttribute("aria-hidden", "true");

    labelGroup.append(label, starIcon);

    const bar = document.createElement("div");
    bar.className = "product-reviews-distribution__bar";
    const fill = document.createElement("span");
    fill.style.width = width + "%";
    bar.append(fill);

    const countEl = document.createElement("span");
    countEl.className = "product-reviews-distribution__count";
    countEl.textContent = count;

    row.append(labelGroup, bar, countEl);
    container.append(row);
  }
}

function renderRecommendText(bottomline) {
  const recommendElement = document.getElementById("product-reviews-recommend");
  if (!recommendElement) return;

  const distribution = getStarDistribution(bottomline);
  const total = bottomline?.total_review || 0;

  if (!total) {
    recommendElement.textContent = "";
    recommendElement.hidden = true;
    return;
  }

  let recommendPercentage = bottomline?.recommended_percentage;

  if (recommendPercentage == null && distribution) {
    const recommended =
      Number(distribution[5] ?? distribution["5"] ?? 0) +
      Number(distribution[4] ?? distribution["4"] ?? 0);
    recommendPercentage = Math.round((recommended / total) * 100);
  }

  recommendElement.hidden = false;
  recommendElement.innerHTML =
    '<span class="product-reviews-summary__recommend-percent">' +
    (recommendPercentage ?? 0) +
    "%</span> would recommend this product.";
}

function getReviewImageSources(image) {
  const thumb =
    image?.thumb_url ||
    image?.thumbnail_url ||
    image?.original_url ||
    image?.url ||
    (typeof image === "string" ? image : null);
  const original =
    image?.original_url ||
    image?.url ||
    image?.thumb_url ||
    image?.thumbnail_url ||
    (typeof image === "string" ? image : null);

  return { thumb, original };
}

function cacheReviewForPreview(review, formatted, cache) {
  const targetCache = cache || reviewPreviewCache;
  const images = (review.images_data || review.images || [])
    .map(getReviewImageSources)
    .filter(function (image) {
      return image.thumb || image.original;
    });

  targetCache.set(String(review.id), {
    userName: formatted.userName,
    createdAt: formatted.createdAt,
    score: review.score,
    title: review.title,
    content: review.content,
    images,
  });
}

function getReviewPreviewModalElements() {
  return {
    modal: document.getElementById("review-image-preview"),
    image: document.getElementById("review-image-preview-image"),
    name: document.getElementById("review-image-preview-name"),
    date: document.getElementById("review-image-preview-date"),
    stars: document.getElementById("review-image-preview-stars"),
    title: document.getElementById("review-image-preview-title"),
    thumbs: document.getElementById("review-image-preview-thumbs"),
    content: document.getElementById("review-image-preview-content"),
    prevButton: document.getElementById("review-image-preview-prev"),
    nextButton: document.getElementById("review-image-preview-next"),
  };
}

function renderReviewImagePreviewModal() {
  const review = getReviewPreviewData(reviewPreviewState.reviewId);
  const elements = getReviewPreviewModalElements();

  if (!review || !elements.modal || !review.images.length) return;

  const imageIndex = Math.min(
    Math.max(reviewPreviewState.imageIndex, 0),
    review.images.length - 1,
  );
  reviewPreviewState.imageIndex = imageIndex;

  const currentImage = review.images[imageIndex];

  elements.image.src = currentImage.original || currentImage.thumb;
  elements.image.alt = "Customer review photo";
  elements.name.textContent = review.userName;
  elements.date.textContent = review.createdAt;
  elements.title.innerHTML = DOMPurify.sanitize(review.title);
  elements.content.innerHTML = DOMPurify.sanitize(review.content);

  renderReviewStars(elements.stars, review.score);

  elements.thumbs.innerHTML = "";
  review.images.forEach(function (image, index) {
    const thumbButton = document.createElement("button");
    thumbButton.type = "button";
    thumbButton.className =
      "review-image-preview__thumb" +
      (index === imageIndex ? " is-active" : "");
    thumbButton.setAttribute("aria-label", "View photo " + (index + 1));

    const thumbImage = document.createElement("img");
    thumbImage.src = image.thumb || image.original;
    thumbImage.alt = "";
    thumbImage.loading = "lazy";

    thumbButton.append(thumbImage);
    thumbButton.addEventListener("click", function () {
      reviewPreviewState.imageIndex = index;
      renderReviewImagePreviewModal();
    });

    elements.thumbs.append(thumbButton);
  });

  elements.thumbs.hidden = review.images.length <= 1;

  const hasMultipleImages = review.images.length > 1;
  elements.prevButton.hidden = !hasMultipleImages;
  elements.nextButton.hidden = !hasMultipleImages;
  elements.prevButton.disabled = imageIndex === 0;
  elements.nextButton.disabled = imageIndex === review.images.length - 1;
}

function openReviewImagePreview(reviewId, imageIndex) {
  const review = getReviewPreviewData(reviewId);
  const elements = getReviewPreviewModalElements();

  if (!review?.images?.length || !elements.modal) return;

  reviewPreviewState = {
    reviewId: String(reviewId),
    imageIndex: imageIndex || 0,
  };

  renderReviewImagePreviewModal();
  elements.modal.hidden = false;
  elements.modal.setAttribute("aria-hidden", "false");
  document.body.classList.add("review-image-preview-open");
}

function closeReviewImagePreview() {
  const elements = getReviewPreviewModalElements();

  if (!elements.modal) return;

  elements.modal.hidden = true;
  elements.modal.setAttribute("aria-hidden", "true");
  document.body.classList.remove("review-image-preview-open");
  elements.image.removeAttribute("src");
}

function shiftReviewImagePreview(step) {
  const review = getReviewPreviewData(reviewPreviewState.reviewId);
  if (!review?.images?.length) return;

  const nextIndex = reviewPreviewState.imageIndex + step;
  if (nextIndex < 0 || nextIndex >= review.images.length) return;

  reviewPreviewState.imageIndex = nextIndex;
  renderReviewImagePreviewModal();
}

function initReviewImagePreview() {
  const elements = getReviewPreviewModalElements();
  const reviewItems = document.getElementById("product-review-items");

  if (!elements.modal || !reviewItems) return;

  const galleryElement = document.getElementById("product-reviews-gallery");

  galleryElement?.addEventListener("click", function (event) {
    const galleryItem = event.target.closest(
      ".product-reviews-summary__gallery-item",
    );
    if (!galleryItem) return;

    openReviewImagePreview(
      galleryItem.dataset.reviewId,
      Number(galleryItem.dataset.imageIndex || 0),
    );
  });

  reviewItems.addEventListener("click", function (event) {
    const imageButton = event.target.closest(".review-item-image");
    if (!imageButton) return;

    const reviewItem = imageButton.closest("[data-review-id]");
    if (!reviewItem) return;

    openReviewImagePreview(
      reviewItem.dataset.reviewId,
      Number(imageButton.dataset.imageIndex || 0),
    );
  });

  document
    .querySelectorAll("[data-review-preview-close]")
    .forEach(function (closeTrigger) {
      closeTrigger.addEventListener("click", closeReviewImagePreview);
    });

  elements.prevButton?.addEventListener("click", function () {
    shiftReviewImagePreview(-1);
  });

  elements.nextButton?.addEventListener("click", function () {
    shiftReviewImagePreview(1);
  });

  document.addEventListener("keydown", function (event) {
    if (elements.modal.hidden) return;

    if (event.key === "Escape") {
      closeReviewImagePreview();
      return;
    }

    if (event.key === "ArrowLeft") {
      shiftReviewImagePreview(-1);
      return;
    }

    if (event.key === "ArrowRight") {
      shiftReviewImagePreview(1);
    }
  });
}

function collectReviewGalleryItems(reviews, limit) {
  const items = [];

  reviews.forEach(function (review, reviewIndex) {
    if (items.length >= limit) return;

    const imageList = review.images_data || review.images || [];
    const reviewId = review.id ?? "gallery-review-" + reviewIndex;
    const { createdAt, userName } = formatReviewDetails({
      createdAt: review.created_at,
      userName: review.user?.display_name,
    });

    cacheReviewForPreview(
      { ...review, id: reviewId },
      { createdAt, userName },
      reviewGalleryPreviewCache,
    );

    imageList.forEach(function (image, imageIndex) {
      if (items.length >= limit) return;

      const sources = getReviewImageSources(image);
      const src = sources.thumb || sources.original;
      if (!src) return;

      items.push({
        reviewId: String(reviewId),
        imageIndex,
        src,
      });
    });
  });

  return items;
}

async function fetchReviewGalleryImages() {
  const picturedData = await getProductReviewsSearchApi({
    productId,
    page: 1,
    per_page: 20,
    pictured: true,
    sort: "date",
    direction: "desc",
  });

  let items = collectReviewGalleryItems(picturedData?.reviews || [], 8);

  if (items.length) {
    return items;
  }

  const generalData = await getProductReviews({
    productId,
    page: 1,
    per_page: 50,
    sort: "date",
    direction: "desc",
  });

  return collectReviewGalleryItems(generalData?.reviews || [], 8);
}

async function renderReviewGallery() {
  const galleryElement = document.getElementById("product-reviews-gallery");
  const gallerySection = galleryElement?.closest(".product-reviews-summary__right");

  if (!galleryElement || reviewGalleryLoaded) return;

  reviewGalleryLoaded = true;

  reviewGalleryPreviewCache.clear();

  const galleryItems = await fetchReviewGalleryImages();

  galleryElement.innerHTML = "";

  if (!galleryItems.length) {
    galleryElement.hidden = true;
    if (gallerySection) {
      gallerySection.classList.remove("has-gallery");
    }
    return;
  }

  galleryElement.hidden = false;
  if (gallerySection) {
    gallerySection.classList.add("has-gallery");
  }

  galleryItems.forEach(function (item) {
    const galleryButton = document.createElement("button");
    galleryButton.type = "button";
    galleryButton.className = "product-reviews-summary__gallery-item";
    galleryButton.dataset.reviewId = item.reviewId;
    galleryButton.dataset.imageIndex = String(item.imageIndex);
    galleryButton.setAttribute("aria-label", "View customer review photo");

    const imageElement = document.createElement("img");
    imageElement.src = item.src;
    imageElement.loading = "lazy";
    imageElement.alt = "";

    galleryButton.append(imageElement);
    galleryElement.append(galleryButton);
  });
}

function initializeNoReviews() {
  const reviewsContentElement = document.querySelector(".reviews-content");
  const productFilterContainerElement = reviewsContentElement?.getElementsByClassName(
    "product-reviews-filters-container",
  );
  const productReviewPaginationElement = reviewsContentElement?.getElementsByClassName(
    "product-review-pagination",
  );
  const emptyProductReviewsElement = reviewsContentElement?.querySelector(
    "#empty-product-reviews",
  );
  const productReviewsBodyElement = reviewsContentElement?.querySelector(
    ".product-reviews-body",
  );
  const productReviewsSummaryElement = document.getElementById(
    "product-reviews-summary",
  );
  const productReviewsToolbarElement = document.querySelector(
    ".product-reviews-toolbar",
  );

  const reviewsHeaderWithData = document.getElementById("reviews-header-with-data");
  const reviewsEmptyHeaderMessage = document.getElementById("reviews-empty-header-message");

  for (const item of productFilterContainerElement || []) {
    item.style.display = "none";
  }

  if (productReviewsSummaryElement) {
    productReviewsSummaryElement.style.display = "none";
  }

  if (productReviewsToolbarElement) {
    productReviewsToolbarElement.style.display = "none";
  }

  if (reviewsHeaderWithData) {
    reviewsHeaderWithData.style.display = "none";
  }

  if (reviewsEmptyHeaderMessage) {
    reviewsEmptyHeaderMessage.style.display = "block";
  }

  for (const item of productReviewPaginationElement || []) {
    item.style.display = "none";
  }

  if (productReviewsBodyElement) {
    productReviewsBodyElement.style.display = "none";
  }

  if (emptyProductReviewsElement) {
    emptyProductReviewsElement.style.display = "flex";
  }
  productReviewsContainer.classList.add("no-reviews");
}

function initializeReviewHeader({ averageScore, numOfTotalReviews, bottomline }) {
  const reviewAverageScoreElement = document.getElementById(
    "product-reviews-info-average",
  );
  const numOfReviewsElement = document.getElementById("product-num-of-reviews");
  const productReviewStarsContainerElement = document.getElementById(
    "review-stars-container",
  );
  const reviewsHeaderWithData = document.getElementById("reviews-header-with-data");
  const reviewsEmptyHeaderMessage = document.getElementById("reviews-empty-header-message");
  const productReviewsSummaryElement = document.getElementById(
    "product-reviews-summary",
  );
  const productReviewsToolbarElement = document.querySelector(
    ".product-reviews-toolbar",
  );

  if (!numOfTotalReviews) {
    initializeNoReviews();
    return;
  }

  if (productReviewsSummaryElement) {
    productReviewsSummaryElement.style.display = "";
  }

  if (productReviewsToolbarElement) {
    productReviewsToolbarElement.style.display = "";
  }

  if (reviewsHeaderWithData) {
    reviewsHeaderWithData.style.display = "";
  }

  if (reviewsEmptyHeaderMessage) {
    reviewsEmptyHeaderMessage.style.display = "none";
  }

  productReviewsContainer.classList.remove("no-reviews");

  reviewAverageScoreElement.innerText = Number(averageScore).toFixed(1);
  numOfReviewsElement.innerText = numOfTotalReviews;
  renderReviewStars(productReviewStarsContainerElement, averageScore);

  if (bottomline) {
    renderStarDistribution(bottomline);
    renderRecommendText(bottomline);
    renderReviewGallery();
  }

  const qandaStars = $("#qanda-stars-container");
  const hasQandaDemo = productReviewsContainer?.dataset?.qandaDemo === "true";

  if (numOfTotalReviews || hasQandaDemo) {
    qandaStars.hide().empty();
  }
}

async function initializeReviewItems({ page, direction, sort, star, pictured, textOnly }) {
  // Use different api endpoint for filter by images and videos
  let bottomline, reviews, pagination
  if (pictured){
     const response = await getProductReviewsSearchApi({
      productId,
      page,
      direction,
      sort,
      star,
      pictured
    });
    bottomline = response.bottomline
    reviews = response.reviews
    pagination = response.pagination
  }else{
     const response = await getProductReviews({
      productId,
      page,
      direction,
      sort,
      star,
    });
    bottomline = response.bottomline
    reviews = response.reviews
    pagination = response.pagination
  }

  if (textOnly) {
    reviews = (reviews || []).filter(function (review) {
      const images = review.images_data || review.images || [];
      return !images.length;
    });
  }

  const { page: currentPage, total } = pagination;
  const totalPage = Math.ceil(total / 5);
  
  if(bottomline){  
    initializeReviewHeader({
      averageScore: bottomline.average_score,
      numOfTotalReviews: bottomline.total_review,
      bottomline,
    });
  }

  initializeReviewPaginationValues(currentPage, totalPage);
  updatePaginationButtonColors(currentPage, totalPage);

  const productReviewItems = document.getElementById("product-review-items");

  productReviewItems.innerHTML = "";

  if(isFiltered() && !reviews.length){
    $(".product-reviews-filter-no-result").css('display', 'flex');
    $(".product-review-pagination").hide();
    return;
  }
  $(".product-reviews-filter-no-result").hide();
  reviewPreviewCache.clear();
  
  for (const [index, review] of reviews.entries()) {
    const { content, created_at, images_data, score, title, user } = review;
    const { display_name } = user;
    const { createdAt, userName } = formatReviewDetails({
      createdAt: created_at,
      userName: display_name,
    });
    const reviewId = review.id ?? "review-" + page + "-" + index;

    cacheReviewForPreview({ ...review, id: reviewId }, { createdAt, userName });

    const reviewItem = document.createElement("li");
    reviewItem.setAttribute("id", "review-item");
    reviewItem.dataset.reviewId = reviewId;

    const reviewItemHeader = document.createElement("div");
    reviewItemHeader.setAttribute("class", "review-item-header");

    const reviewItemBody = document.createElement("div");
    reviewItemBody.setAttribute("class", "review-item-body");

    const reviewCustomerName = document.createElement("p");
    reviewCustomerName.setAttribute("id", "review-customer-name");
    reviewCustomerName.appendChild(document.createTextNode(userName));

    const reviewDateCreated = document.createElement("p");
    reviewDateCreated.setAttribute("id", "review-date-created");
    reviewDateCreated.appendChild(document.createTextNode(createdAt));

    const reviewStars = document.createElement("div");
    reviewStars.setAttribute("id", "review-stars");
    for (let scoreCount = 0; scoreCount < 5; scoreCount++) {
      const reviewStarImage = document.createElement("img");
      reviewStarImage.setAttribute("loading", "lazy");

      const hasStarCountEnded = score - 1 < scoreCount;

      reviewStarImage.src = hasStarCountEnded ? STAR_EMPTY : STAR_FILLED;

      reviewStars.append(reviewStarImage);
    }

    const reviewTitle = document.createElement("h4");
    reviewTitle.setAttribute("id", "review-title");
    reviewTitle.innerHTML = DOMPurify.sanitize(title);

    const reviewContent = document.createElement("p");
    reviewContent.setAttribute("id", "review-content");
    reviewContent.innerHTML = DOMPurify.sanitize(content);

    const reviewImages = document.createElement("div");
    reviewImages.setAttribute("id", "review-images");
    images_data?.forEach(function (image, imageIndex) {
      const sources = getReviewImageSources(image);
      if (!sources.thumb && !sources.original) return;

      const reviewImageButton = document.createElement("button");
      reviewImageButton.type = "button";
      reviewImageButton.className = "review-item-image";
      reviewImageButton.dataset.imageIndex = String(imageIndex);
      reviewImageButton.setAttribute("aria-label", "View review photo");

      const reviewImage = document.createElement("img");
      reviewImage.setAttribute("loading", "lazy");
      reviewImage.src = sources.thumb || sources.original;
      reviewImage.alt = "Customer review photo";

      reviewImageButton.append(reviewImage);
      reviewImages.append(reviewImageButton);
    });

    reviewItemHeader.append(reviewCustomerName);
    reviewItemHeader.append(reviewDateCreated);

    reviewItemBody.append(reviewStars);
    reviewItemBody.append(reviewTitle);
    reviewItemBody.append(reviewContent);
    reviewItemBody.append(reviewImages);

    reviewItem.append(reviewItemHeader);
    reviewItem.append(reviewItemBody);

    productReviewItems.append(reviewItem);
  }
}

function getReviewPageData() {
  const totalPage = document.getElementById(
    "product-review-total-page",
  ).innerText;
  const currentPage = document.getElementById(
    "product-review-current-page",
  ).innerText;

  return { currentPage: Number(currentPage), totalPage: Number(totalPage) };
}

productReviewPrevButtonElement.onclick = function () {
  const { currentPage, totalPage } = getReviewPageData();
  const {star, pictured, textOnly, sort, direction} = getFilterAndSortValues();
  
  resetPaginationButtonColors();

  const isPageOutOfBounds = preventPaginationOvershooting(
    currentPage,
    totalPage,
    "PREV",
  );

  if (isPageOutOfBounds) return;

  initializeReviewItems({ page: currentPage - 1, star, pictured, textOnly, sort, direction });
};

productReviewNextButtonElement.onclick = function () {
  const { currentPage, totalPage } = getReviewPageData();
  const {star, pictured, textOnly, sort, direction} = getFilterAndSortValues();
  
  resetPaginationButtonColors();

  const isPageOutOfBounds = preventPaginationOvershooting(
    currentPage,
    totalPage,
    "NEXT",
  );

  if (isPageOutOfBounds) return;

  initializeReviewItems({ page: currentPage + 1, star, pictured, textOnly, sort, direction });
};

initializeReviewItems({ page: 1 });
initReviewImagePreview();

const writeAReviewCloseButton = document.getElementById(
  "write-a-review-close-button",
);

writeAReviewCloseButton?.addEventListener("click", function () {
  if (isWriteAReviewSubmitting) return;

  writeAReviewModalElement.style.display = "none";
  resetWriteAReviewModalReOpen();
});

function handleOpenWriteAReviewModal() {
  writeAReviewModalElement.style.display = "flex";
  const customerEmail = getUserEmail();

  document.getElementById("write-a-review-email-input").value = customerEmail;
  clearWriteAReviewValidation();
  updateWriteAReviewFormValidation();
}

const writeAReviewOpenButton = document.getElementById(
  "write-product-reviews-button",
);

writeAReviewOpenButton?.addEventListener("click", function () {
  handleOpenWriteAReviewModal();
});

document.querySelectorAll(".empty-write-a-review-link").forEach(function (link) {
  link.addEventListener("click", function () {
    handleOpenWriteAReviewModal();
  });
});

const writeAReviewStarButtons = document.querySelectorAll(
  "#star-selector-container .star-selector-container__star",
);

function handleWriteAReviewRating(score) {
  writeAReviewStarButtons.forEach(function (starButton) {
    const starImage = starButton.querySelector("img");
    const starScore = +starButton.dataset.score;

    if (starImage) {
      starImage.src = starScore <= +score ? STAR_FILLED : STAR_EMPTY;
    }
  });

  const starSelectorElement = document.getElementById(
    "star-selector-container",
  );
  starSelectorElement.dataset.currentScore = score;
  updateWriteAReviewFormValidation();
}

writeAReviewStarButtons.forEach(function (starButton) {
  starButton.addEventListener("click", function () {
    handleWriteAReviewRating(starButton.dataset.score);
  });
});

let hasAttemptedWriteAReviewSubmit = false;
let isWriteAReviewSubmitting = false;
const MAX_MEDIA_FILE_SIZE = 20 * 1024 * 1024;

const writeAReviewMediaButton = document.getElementById(
  "write-a-review-media-button",
);
const writeAReviewMediaInput = document.getElementById(
  "write-a-review-media-input",
);
const writeAReviewMediaPreviews = document.getElementById(
  "write-a-review-media-previews",
);
let writeAReviewMediaFiles = [];
let writeAReviewMediaPreviewUrls = [];
let writeAReviewMediaHasSizeError = false;

writeAReviewMediaButton?.addEventListener("click", function () {
  writeAReviewMediaInput?.click();
});

writeAReviewMediaInput?.addEventListener("change", function () {
  addWriteAReviewMediaFiles(writeAReviewMediaInput.files);
  writeAReviewMediaInput.value = "";
});

function addWriteAReviewMediaFiles(fileList) {
  if (!fileList?.length) return;

  const imageFiles = Array.from(fileList).filter(function (file) {
    return YOTPO_REVIEW_IMAGE_TYPES.indexOf(file.type) !== -1;
  });

  writeAReviewMediaHasSizeError = false;

  imageFiles.forEach(function (file) {
    if (file.size > MAX_MEDIA_FILE_SIZE) {
      writeAReviewMediaHasSizeError = true;
      hasAttemptedWriteAReviewSubmit = true;
      return;
    }

    if (writeAReviewMediaFiles.length < YOTPO_MAX_REVIEW_IMAGES) {
      writeAReviewMediaFiles.push(file);
    }
  });

  renderWriteAReviewMediaPreviews();
  updateWriteAReviewFormValidation();
}

function renderWriteAReviewMediaPreviews() {
  if (!writeAReviewMediaPreviews) return;

  writeAReviewMediaPreviewUrls.forEach(function (previewUrl) {
    URL.revokeObjectURL(previewUrl);
  });

  writeAReviewMediaPreviewUrls = [];
  writeAReviewMediaPreviews.innerHTML = "";

  if (!writeAReviewMediaFiles.length) {
    writeAReviewMediaPreviews.hidden = true;
    return;
  }

  writeAReviewMediaFiles.forEach(function (file, index) {
    const previewUrl = URL.createObjectURL(file);
    writeAReviewMediaPreviewUrls.push(previewUrl);

    const previewItem = document.createElement("div");
    previewItem.className = "write-a-review-media-preview";

    const previewImage = document.createElement("img");
    previewImage.src = previewUrl;
    previewImage.alt = file.name;

    const removeButton = document.createElement("button");
    removeButton.type = "button";
    removeButton.className = "write-a-review-media-preview__remove";
    removeButton.setAttribute("aria-label", "Remove photo");
    removeButton.innerHTML =
      '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M8 8L2 2M8 2L2 8" stroke="#352B27" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    removeButton.addEventListener("click", function () {
      removeWriteAReviewMediaFile(index);
    });

    previewItem.appendChild(previewImage);
    previewItem.appendChild(removeButton);
    writeAReviewMediaPreviews.appendChild(previewItem);
  });

  writeAReviewMediaPreviews.hidden = false;
}

function removeWriteAReviewMediaFile(index) {
  if (writeAReviewMediaPreviewUrls[index]) {
    URL.revokeObjectURL(writeAReviewMediaPreviewUrls[index]);
  }

  writeAReviewMediaFiles.splice(index, 1);
  renderWriteAReviewMediaPreviews();
  updateWriteAReviewFormValidation();
}

function clearWriteAReviewMediaPreviews() {
  writeAReviewMediaPreviewUrls.forEach(function (previewUrl) {
    URL.revokeObjectURL(previewUrl);
  });

  writeAReviewMediaFiles = [];
  writeAReviewMediaPreviewUrls = [];
  writeAReviewMediaHasSizeError = false;

  if (writeAReviewMediaInput) {
    writeAReviewMediaInput.value = "";
  }

  if (writeAReviewMediaPreviews) {
    writeAReviewMediaPreviews.innerHTML = "";
    writeAReviewMediaPreviews.hidden = true;
  }
}

const writeAReviewRecommend = document.getElementById(
  "write-a-review-recommend",
);
const writeAReviewRecommendOptions = document.querySelectorAll(
  ".write-a-review-recommend__option",
);

writeAReviewRecommendOptions.forEach(function (option) {
  option.addEventListener("click", function () {
    writeAReviewRecommendOptions.forEach(function (recommendOption) {
      recommendOption.classList.remove("is-selected");
      recommendOption.setAttribute("aria-pressed", "false");
    });

    option.classList.add("is-selected");
    option.setAttribute("aria-pressed", "true");

    if (writeAReviewRecommend) {
      writeAReviewRecommend.dataset.value = option.dataset.value;
    }

    updateWriteAReviewFormValidation();
  });
});

function setWriteAReviewModalTitle(title) {
  const modalTitle = document.getElementById("write-a-review-modal-title");
  if (modalTitle) modalTitle.innerText = title;
}

function resetWriteAReviewModalReOpen() {
  document
    .querySelector("#write-a-review-container #review-submit-mesasge-container")
    .style.display = "none";
  document.querySelector("#write-a-review-container #write-a-review-form").style.display =
    "block";
  setWriteAReviewSubmitting(false);
  setWriteAReviewModalTitle("Leave a review");
}

function switchWriteAReviewModalContent() {
  document
    .querySelector("#write-a-review-container #review-submit-mesasge-container")
    .style.display = "flex";
  document.querySelector("#write-a-review-container #write-a-review-form").style.display =
    "none";
}

function setWriteAReviewSubmitting(isSubmitting) {
  isWriteAReviewSubmitting = isSubmitting;

  const wrapper = document.querySelector(
    "#write-a-review-container .write-a-review-wrapper--review",
  );
  const loading = document.getElementById("write-a-review-loading");

  wrapper?.classList.toggle("is-submitting", isSubmitting);

  if (loading) {
    loading.hidden = !isSubmitting;
  }

  if (writeAReviewButton) {
    const label = writeAReviewButton.querySelector(
      ".write-a-review-submit-button__label",
    );

    writeAReviewButton.classList.toggle("is-loading", isSubmitting);
    writeAReviewButton.setAttribute("aria-busy", String(isSubmitting));
    writeAReviewButton.setAttribute("aria-disabled", String(isSubmitting || !isWriteAReviewFormValid(getWriteAReviewFormValues())));

    if (label) {
      label.textContent = isSubmitting ? "Submitting…" : "Submit";
    }
  }

  if (writeAReviewCloseButton) {
    writeAReviewCloseButton.disabled = isSubmitting;
  }
}

function successWritingAReview() {
  setWriteAReviewSubmitting(false);
  switchWriteAReviewModalContent();
  setWriteAReviewModalTitle("Thanks for leaving a review!");

  document.getElementById("review-after-submit-message").innerText =
    "We really appreciate you taking the time to share your rating with us.";

  document.getElementById("review-after-submit-button").style.display = "";
}

function errorWritingAReview() {
  setWriteAReviewSubmitting(false);
  switchWriteAReviewModalContent();
  setWriteAReviewModalTitle("Oops!");

  document.getElementById("review-after-submit-message").innerText =
    "There's an error submitting your review.";

  document.getElementById("review-after-submit-button").style.display = "none";
}

function resetWriteAReviewForm() {
  document.getElementById("write-a-review-email-input").value = "";
  document.getElementById("star-selector-container").dataset.currentScore = 0;
  document.getElementById("write-a-review-name-input").value = "";
  document.getElementById("write-a-review-description-textarea").value = "";
  document.getElementById("write-a-review-title-input").value = "";
  handleWriteAReviewRating(0);

  if (writeAReviewRecommend) {
    writeAReviewRecommend.dataset.value = "";
  }

  writeAReviewRecommendOptions.forEach(function (option) {
    option.classList.remove("is-selected");
    option.setAttribute("aria-pressed", "false");
  });

  if (writeAReviewMediaInput) {
    writeAReviewMediaInput.value = "";
  }

  clearWriteAReviewMediaPreviews();
  clearWriteAReviewValidation();
}

async function handleWriteAReview(reviewData) {
  if (isWriteAReviewSubmitting) return;

  setWriteAReviewSubmitting(true);

  try {
    const reviewImages = getReviewImageFiles(reviewData?.mediaFiles);
    const imageUrls = reviewImages.length
      ? await uploadReviewImagesToPublicUrls(reviewImages)
      : [];

    const payload = {
      appkey: YOTPO_APP_KEY,
      domain: reviewData?.shopDomain ?? shopDomain,
      sku: reviewData?.productId ?? "",
      product_title: reviewData?.productTitle ?? "",
      product_description: reviewData?.productDescription ?? "",
      product_url: reviewData?.productUrl ?? "",
      product_image_url: reviewData?.productImageUrl ?? "",
      display_name: reviewData?.customerName ?? "",
      email: reviewData?.customerEmail ?? "",
      is_incentivized: false,
      review_content: reviewData?.reviewContent ?? "",
      review_title: reviewData?.reviewTitle ?? "",
      review_score: reviewData?.reviewScore ?? 0,
    };

    const response = await createYotpoReview(payload);

    if (isYotpoReviewCreated(response)) {
      const imageUploadToken = getYotpoImageUploadToken(response);

      if (imageUploadToken && imageUrls.length) {
        await attachYotpoReviewImages(imageUploadToken, imageUrls);
      }

      successWritingAReview();
    } else {
      errorWritingAReview();
    }

    resetWriteAReviewForm();
  } catch (error) {
    console.error(error);
    errorWritingAReview();
  }
}

function getReviewImageFiles(mediaFiles) {
  if (!mediaFiles?.length) return [];

  return mediaFiles
    .filter(function (file) {
      return YOTPO_REVIEW_IMAGE_TYPES.indexOf(file.type) !== -1;
    })
    .slice(0, YOTPO_MAX_REVIEW_IMAGES);
}

function isYotpoReviewCreated(response) {
  if (!response) return false;

  return (
    response.code === 200 ||
    response.code === "200" ||
    response.status === 200 ||
    response.status?.code === 200 ||
    response.message === "ok" ||
    !!getYotpoImageUploadToken(response)
  );
}

function getYotpoImageUploadToken(response) {
  return (
    response?.image_upload_token ||
    response?.response?.image_upload_token ||
    ""
  );
}

async function createYotpoReview(payload) {
  const options = {
    method: "POST",
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  };

  const dynamicRes = await fetch(
    "https://api.yotpo.com/reviews/dynamic_create",
    options,
  );
  const dynamicResponse = await parseJsonResponse(dynamicRes);

  if (isYotpoReviewCreated(dynamicResponse)) {
    return dynamicResponse;
  }

  const widgetRes = await fetch(
    "https://api.yotpo.com/v1/widget/reviews",
    options,
  );
  return parseJsonResponse(widgetRes);
}

async function parseJsonResponse(res) {
  try {
    return await res.json();
  } catch (error) {
    return null;
  }
}

async function uploadReviewImagesToPublicUrls(imageFiles) {
  const uploads = await Promise.allSettled(
    imageFiles.map(uploadReviewImageToPublicUrl),
  );

  return uploads
    .map(function (result) {
      return result.status === "fulfilled" ? result.value : "";
    })
    .filter(Boolean)
    .slice(0, YOTPO_MAX_REVIEW_IMAGES);
}

async function uploadReviewImageToPublicUrl(imageFile) {
  const formData = new FormData();
  formData.append("file", imageFile, imageFile.name);

  const res = await fetch("https://tmpfiles.org/api/v1/upload", {
    method: "POST",
    body: formData,
  });

  if (!res.ok) return "";

  const data = await res.json();
  const pageUrl = data?.data?.url || "";
  if (!pageUrl) return "";

  return pageUrl.replace("tmpfiles.org/", "tmpfiles.org/dl/");
}

async function attachYotpoReviewImages(imageUploadToken, imageUrls) {
  const res = await fetch("https://api.yotpo.com/images/process", {
    method: "POST",
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      image_upload_token: imageUploadToken,
      image_urls: imageUrls,
    }),
  });

  if (!res.ok) {
    console.error("Yotpo image attach failed", await parseJsonResponse(res));
  }
}

function getUserEmail() {
  const customerData = mainShopifyData?.customer ?? {};

  if (!Object.keys(customerData).length) {
    return "";
  }

  return customerData?.email ?? "";
}

const writeAReviewButton = document.getElementById(
  "write-a-review-submit-button",
);

[
  "write-a-review-title-input",
  "write-a-review-description-textarea",
  "write-a-review-name-input",
  "write-a-review-email-input",
].forEach(function (inputId) {
  document.getElementById(inputId)?.addEventListener("input", function () {
    updateWriteAReviewFormValidation();
  });
});

function getWriteAReviewFormValues() {
  const starSelectorElement = document.getElementById("star-selector-container");
  const email =
    document.getElementById("write-a-review-email-input")?.value?.trim() ?? "";

  return {
    rating: +(starSelectorElement?.dataset?.currentScore ?? 0),
    title:
      document.getElementById("write-a-review-title-input")?.value?.trim() ?? "",
    description:
      document.getElementById("write-a-review-description-textarea")?.value?.trim() ??
      "",
    name:
      document.getElementById("write-a-review-name-input")?.value?.trim() ?? "",
    email,
    recommend: writeAReviewRecommend?.dataset?.value ?? "",
    hasOversizedMedia: writeAReviewMediaHasSizeError,
  };
}

function isWriteAReviewFormValid(values) {
  return (
    values.rating > 0 &&
    !!values.title &&
    !!values.description &&
    !!values.recommend &&
    !!values.name &&
    !!values.email &&
    validateEmail(values.email) &&
    !values.hasOversizedMedia
  );
}

function setWriteAReviewFieldError(fieldKey, hasError, message) {
  if (fieldKey === "media") {
    document
      .querySelector(".write-a-review-form-item--media")
      ?.classList.toggle("is-error", hasError);
    return;
  }

  const errorElement = document.getElementById(
    "write-a-review-" + fieldKey + "-error",
  );

  if (errorElement) {
    if (message) {
      errorElement.textContent = message;
    }
    errorElement.hidden = !hasError;
  }

  const inputIdMap = {
    title: "write-a-review-title-input",
    description: "write-a-review-description-textarea",
    name: "write-a-review-name-input",
    email: "write-a-review-email-input",
  };

  if (inputIdMap[fieldKey]) {
    document
      .getElementById(inputIdMap[fieldKey])
      ?.closest(".write-a-review-form-item")
      ?.classList.toggle("is-error", hasError);
  }
}

function clearWriteAReviewValidation() {
  hasAttemptedWriteAReviewSubmit = false;

  ["rating", "title", "description", "media", "recommend", "name", "email"].forEach(
    function (fieldKey) {
      setWriteAReviewFieldError(fieldKey, false);
    },
  );

  updateWriteAReviewSubmitState();
}

function updateWriteAReviewFormValidation() {
  const values = getWriteAReviewFormValues();

  if (hasAttemptedWriteAReviewSubmit) {
    setWriteAReviewFieldError("rating", !values.rating);
    setWriteAReviewFieldError("title", !values.title);
    setWriteAReviewFieldError("description", !values.description);
    setWriteAReviewFieldError("recommend", !values.recommend);
    setWriteAReviewFieldError("name", !values.name);

    if (!values.email) {
      setWriteAReviewFieldError("email", true, "Enter your email address");
    } else if (!validateEmail(values.email)) {
      setWriteAReviewFieldError("email", true, "Enter a valid email address");
    } else {
      setWriteAReviewFieldError("email", false);
    }
  } else {
    ["rating", "title", "description", "recommend", "name", "email"].forEach(
      function (fieldKey) {
        setWriteAReviewFieldError(fieldKey, false);
      },
    );
  }

  setWriteAReviewFieldError("media", values.hasOversizedMedia);
  updateWriteAReviewSubmitState(values);
}

function updateWriteAReviewSubmitState(values) {
  values = values ?? getWriteAReviewFormValues();
  const isValid = isWriteAReviewFormValid(values);

  if (writeAReviewButton) {
    writeAReviewButton.classList.toggle("is-disabled", !isValid || isWriteAReviewSubmitting);
    writeAReviewButton.setAttribute(
      "aria-disabled",
      String(!isValid || isWriteAReviewSubmitting),
    );
  }
}

writeAReviewButton?.addEventListener("click", function () {
  if (isWriteAReviewSubmitting) return;

  hasAttemptedWriteAReviewSubmit = true;

  const values = getWriteAReviewFormValues();
  updateWriteAReviewFormValidation();

  if (!isWriteAReviewFormValid(values)) return;

  const data = {
    productId: productId,
    productTitle: productTitle,
    productDescription: productDescription,
    productUrl: productUrl,
    productImageUrl: productImageUrl,
    shopDomain: shopDomain,
    customerName: values.name,
    customerEmail: values.email,
    reviewContent: values.description,
    reviewTitle: values.title,
    reviewScore: values.rating,
    mediaFiles: writeAReviewMediaFiles,
  };

  handleWriteAReview(data);
});

function validateEmail(email) {
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
}

updateWriteAReviewFormValidation();

const reviewAfterSubmitButton = document.getElementById(
  "review-after-submit-button",
);

reviewAfterSubmitButton.onclick = function () {
  writeAReviewModalElement.style.display = "none";
  resetWriteAReviewModalReOpen();
};

const productReviewsSortButton = document.getElementById(
  "product-reviews-sort-button",
);

productReviewsSortButton.onclick = function () {
  const productReviewsSortDropdownElement = document.getElementById(
    "product-reviews-sort-dropdown",
  );
  const buttonChevron = productReviewsSortButton.querySelector(
    ".product-reviews-chevron",
  );

  const isDropdownOpen =
    productReviewsSortDropdownElement.style.display === "block";

  buttonChevron.style.transform = isDropdownOpen
    ? "rotate(0)"
    : "rotate(3.142rad)";

  productReviewsSortDropdownElement.style.display = isDropdownOpen
    ? "none"
    : "block";
};

const productReviewsSortDropdownElement = document.getElementById(
  "product-reviews-sort-dropdown",
);

function resetSortDropdownBackgroundColors() {
  const dropdownItems =
    productReviewsSortDropdownElement.querySelectorAll("li");

  for (const item of dropdownItems) {
    item.style.backgroundColor = "#ffffff";
  }
}

function getSortValues(dataString) {
  if (dataString === "rating:low-to-high") {
    return {
      direction: "desc",
      sort: "rating",
    };
  }

  if (dataString === "rating:hight-to-low") {
    return {
      direction: "asc",
      sort: "rating",
    };
  }

  if (dataString === "most-recent") {
    return {
      direction: "desc",
      sort: "date",
    };
  }

  if (dataString === "most-helpful") {
    return {
      direction: "desc",
      sort: "votes_up",
    };
  }

  return {
    direction: "desc",
    sort: "rating",
  };
}

productReviewsSortDropdownElement.onclick = function (el) {
  const { target } = el;
  const { attributes } = target;
  const { value } = attributes;
  const { value: selectedValue } = value;

  resetSortDropdownBackgroundColors();

  $("#product-reviews-sort-dropdown").data("value", selectedValue);
  $(el.target).parent("ul").siblings("#product-reviews-sort-button").children("span").text($(el.target).text() === 'Rating, high to low' ? 'Sort' : $(el.target).text())
  $(el.target).parent("ul").siblings("#product-reviews-sort-button").find(".product-reviews-chevron").css("transform", "rotate(0)")
  
  target.style.backgroundColor = "#E8E8E4";

  const sortValues = getSortValues(selectedValue);

  initializeReviewItems({
    direction: sortValues.direction,
    sort: sortValues.sort,
  });

  this.style.display = "none";
};

const reviewFilterContainerElement = document.getElementById(
  "review-filter-container",
);

const closeReviewFilterButton = document.getElementById(
  "close-review-filter-button",
);

closeReviewFilterButton.onclick = function () {
  reviewFilterContainerElement.style.display = "none";
  document.body.classList.remove("review-filter-open");
};

const productReviewFilterButton = document.getElementById(
  "product-reviews-filter-button",
);

productReviewFilterButton.onclick = function () {
  reviewFilterContainerElement.style.display = "block";
  document.body.classList.add("review-filter-open");
};

const reviewFilterRatingSelectElement = document.getElementById(
  "review-filter-rating-select",
);

const reviewFilterRatingSelectItems =
  reviewFilterRatingSelectElement.querySelectorAll(
    ".review-filter-select-item",
  );

function resetFilterSelect(selectItems) {
  for (const item of selectItems) {
    item.querySelector(".review-filter-select-checkbox")?.classList.remove("selected");
  }
}

function selectFilterItem(item, selectItems) {
  if (!item) return null;

  resetFilterSelect(selectItems);
  item.querySelector(".review-filter-select-checkbox")?.classList.add("selected");

  return item.getAttribute("value");
}

function handleFilterSectionClick(event, selectItems) {
  const item = event.target.closest(".review-filter-select-item");
  const items = Array.from(selectItems);

  if (!item || !items.includes(item)) return null;

  return selectFilterItem(item, items);
}

function getSelectedContentFilterValue() {
  const selectedItem = reviewFilterReviewWrapper.querySelector(
    ".review-filter-select-item .review-filter-select-checkbox.selected",
  )?.closest(".review-filter-select-item");

  return selectedItem?.getAttribute("value") || "all-reviews";
}

function getContentFilterFlags(contentValue) {
  return {
    pictured: contentValue === "with-images-and-videos",
    textOnly: contentValue === "text-reviews",
  };
}

const reviewFilterReviewWrapper = document.getElementById(
  "review-filter-review-wrapper",
);

const filterReviewsSelectItems = reviewFilterReviewWrapper.querySelectorAll(
  ".review-filter-select-item",
);

reviewFilterRatingSelectElement.onclick = function (event) {
  handleFilterSectionClick(event, reviewFilterRatingSelectItems);
};

reviewFilterReviewWrapper.onclick = function (event) {
  handleFilterSectionClick(event, filterReviewsSelectItems);
};

const filterClearButton = document.getElementById("review-filter-clear-button");

filterClearButton.onclick = function () {
  resetFilterSelect(reviewFilterRatingSelectItems);
  resetFilterSelect(filterReviewsSelectItems);

  reviewFilterRatingSelectItems.item(0)
    ?.querySelector(".review-filter-select-checkbox")
    ?.classList.add("selected");

  filterReviewsSelectItems.item(0)
    ?.querySelector(".review-filter-select-checkbox")
    ?.classList.add("selected");
};

const filterApplyButton = document.getElementById("review-filter-apply-button");

function findFilterSelectedValue(selectItems) {
  const selectedItem = Array.from(selectItems).find(function (item) {
    return item
      .querySelector(".review-filter-select-checkbox")
      ?.classList.contains("selected");
  });

  return selectedItem?.getAttribute("value") ?? "";
}

filterApplyButton.onclick = function () {
  
  const sortValues = getSortValues($("#product-reviews-sort-dropdown").data("value"));

  const filterRatingsSelectedValue = findFilterSelectedValue(
    reviewFilterRatingSelectItems,
  );

  reviewFilterContainerElement.style.display = "none";
  document.body.classList.remove("review-filter-open");

  const star =
    filterRatingsSelectedValue === "all"
      ? undefined
      : +filterRatingsSelectedValue;
  
  const contentValue = getSelectedContentFilterValue();
  const { pictured, textOnly } = getContentFilterFlags(contentValue);

  initializeReviewItems({
    page: 1,
    direction: sortValues.direction,
    sort: sortValues.sort,
    star,
    pictured,
    textOnly,
  });
};

// Event Listeners
$("#product-reviews-filter-dropdowns-rating").click(function(){
  $(".product-reviews-filter-dropdowns > div > button").not(this).removeClass("active")
  $(this).toggleClass("active")
})
$("#product-reviews-filter-dropdowns-all-reviews").click(function(){
  $(".product-reviews-filter-dropdowns > div > button").not(this).removeClass("active")
  $(this).toggleClass("active")
})
$("#product-reviews-filter-dropdowns-clear").click(function(){
  $(this).removeClass("is-visible");
  $(".product-reviews-filter-dropdowns > div > ul > li").removeClass("active")
  $(".product-reviews-filter-dropdowns > div > ul > li[data-value=all-reviews]").addClass("active")
  $("#product-reviews-filter-dropdowns-rating").removeData("value")
  $("#product-reviews-filter-dropdowns-all-reviews").removeData("value")
  $("#product-reviews-filter-dropdowns-all-reviews > span").text("All Content")
  $("#product-reviews-filter-dropdowns-rating > span").text("All Ratings")
  resetPaginationButtonColors();
  initializeReviewItems({})
})
$(".product-reviews-filter-dropdowns > div > ul > li").click(function(){
  $(this).parent("ul").prev().data("value", $(this).data("value"))
  $(this).parent("ul").prev().removeClass("active")
  $(this).parent("ul").children("li").removeClass("active")
  $(this).parent("ul").siblings("#product-reviews-filter-dropdowns-all-reviews").children("span").text($(this).text())
  $(this).parent("ul").siblings("#product-reviews-filter-dropdowns-rating").children("span").html($(this).html())
  $(this).addClass("active")
  const {star, pictured, sort, direction} = getFilterAndSortValuesDesktop()
  initializeReviewItems({ star, pictured, sort, direction })
})

function isFiltered(){
   const valuesMobile = getFilterAndSortValues()
   const valuesDesktop = getFilterAndSortValuesDesktop()
   if(valuesMobile.pictured || valuesMobile.textOnly || valuesMobile.star || valuesDesktop.pictured || valuesDesktop.star) return true
   return false
}

function getFilterAndSortValues(){
  const sortValues = getSortValues($("#product-reviews-sort-dropdown").data("value"));

  const filterRatingsSelectedValue = findFilterSelectedValue(
    reviewFilterRatingSelectItems,
  );

  const star =
    filterRatingsSelectedValue === "all"
      ? undefined
      : +filterRatingsSelectedValue;

  const contentValue = getSelectedContentFilterValue();
  const { pictured, textOnly } = getContentFilterFlags(contentValue);

  return {
    star,
    pictured,
    textOnly,
    sort: sortValues.sort,
    direction: sortValues.direction
  }
}

function getFilterAndSortValuesDesktop(){
  const sortValues = getSortValues($("#product-reviews-sort-dropdown").data("value"));

  const star = $("#product-reviews-filter-dropdowns-rating").data("value")  
  const pictured = $("#product-reviews-filter-dropdowns-all-reviews").data("value") === "with-images-and-videos" ? true : false
 
  return {
    star,
    pictured,
    sort: sortValues.sort,
    direction: sortValues.direction
  }
}
// Scroll to reviews on click
$("#product-information-reviews").click(function(){
  $('html, body').animate({
    scrollTop: $("#product-reviews-container").offset().top - 100
  }, 100)
})